import Tables from 'src/class/Tables';
import Formatter from 'src/class/Formatter';
import UnitPriceErrorFormatter from './UnitPriceErrorFormatter';
import SubTotalErrorFormatter from './SubTotalErrorFormatter';
import IncrementRateFormatter from './IncrementRateFormatter';
import i18n from 'src/i18n';

const configTable = () => {
  const Table = { ...Tables.Table };
  Table.tableColumns = [
    {
      prop: 'date_save',
      label: i18n.t('common_words.date'),
      minWidth: 150,
      sortable: true,
      align: 'center',
    },
    {
      prop: 'worker.code',
      label: i18n.t('labor.worker'),
      minWidth: 180,
      sortable: true,
    },
    {
      prop: 'worker.code',
      label: `${i18n.t('common_words.name')} ${i18n.t('labor.worker')}`,
      sortable: true,
      minWidth: 180,
      align: 'center',
      formatter: (row) => `${row.worker.first_name} ${row.worker.last_name}`
    },
    {
      prop: 'activity_code',
      label: i18n.t('common_words.activity'),
      minWidth: 100,
      sortable: true,
      align: 'center',
    },
    {
      prop: 'activity_name',
      label: `${i18n.t('common_words.name')} 
        ${i18n.t('common_words.from').toLowerCase()} 
        ${i18n.t('common_words.activity')}`,
      minWidth: 200,
      sortable: true,
      align: 'center',
    },
    {
      prop: 'quantity',
      label: i18n.t('common_words.quantity'),
      minWidth: 100,
      sortable: true,
      align: 'center',
    },
    {
      prop: 'number_hours',
      label: i18n.t('common_words.duration'),
      minWidth: 100,
      sortable: true,
      align: 'center',
    },
    {
      prop: 'activity',
      label: i18n.t('labor.unitary_value'),
      minWidth: 150,
      sortable: true,
      align: 'center',
      formatter: UnitPriceErrorFormatter,
    },
    {
      prop: 'farm_name',
      label: `${i18n.t('common_words.name')} ${i18n.t('common_words.farm')}`,
      minWidth: 200,
      sortable: true,
    },
    {
      prop: 'lot_name',
      label: i18n.t('common_words.allotment'),
      minWidth: 120,
      sortable: true,
      align: 'center',
    },
    {
      prop: 'activity.unit_payment_name',
      label: i18n.t('labor.unit'),
      minWidth: 120,
      sortable: true,
      align: 'center',
    },
    {
      prop: 'subtotal',
      label: i18n.t('common_words.value_total'),
      minWidth: 180,
      sortable: true,
      align: 'center',
      formatter: SubTotalErrorFormatter,
    },
    {
      prop: 'time_type',
      label: i18n.t('labor.hour_type'),
      minWidth: 220,
      sortable: true,
      formatter: (row, column) => {
        const { price_format, name, price } = row[column.property];
        const pre = price_format === '$' ? price_format : '';
        const post = price_format === '%' ? price_format : '';
        let text = `${name} ${pre}${Formatter.formatNumber(
          Number(price)
        )}${post} adicional`;

        return text;
      },
    },
    {
      prop: 'increment_rates',
      label: i18n.t('common_words.increments'),
      minWidth: 350,
      formatter: IncrementRateFormatter,
    },
    {
      prop: 'observations',
      label: i18n.t('common_words.observation'),
      minWidth: 250,
      sortable: true,
    },
  ];

  return { Table };
};

export default configTable;
